import { render, staticRenderFns } from "./PanelConsejera.vue?vue&type=template&id=61860f82&scoped=true&"
import script from "./PanelConsejera.vue?vue&type=script&lang=js&"
export * from "./PanelConsejera.vue?vue&type=script&lang=js&"
import style0 from "./PanelConsejera.vue?vue&type=style&index=0&id=61860f82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61860f82",
  null
  
)

export default component.exports